<template>
    <div id="page-box">
        <transition name="slide-fade">
            <div class="page">
                <h1>&nbsp;<i class="fa fa-table"></i> Markdown(GFM) Cheat Sheet</h1>

                <sheet-table />

            </div>
        </transition>
    </div>
</template>

<script>
import SheetTable from "./CheatSheetTable.vue";

export default {
    name: 'sb-home' ,
    components: {
        "sheet-table": SheetTable
    }
}
</script>
